import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Funciona si llevo años sin dormir bien?',
    a: 'Sí. El protocolo está diseñado específicamente para personas con patrones de sueño alterados crónicamente. La mayoría nota cambios desde la primera semana.'
  }, {
    q: '¿Necesito comprar suplementos o productos especiales?',
    a: 'No. Todo el protocolo usa hábitos, técnicas de respiración y ajustes de estilo de vida. Sin suplementos, sin gadgets, sin gastos adicionales.'
  }, {
    q: '¿Funciona para hombres y mujeres?',
    a: 'Sí. El cortisol nocturno elevado afecta a ambos por igual. El protocolo está diseñado para cualquier adulto independientemente del género.'
  }, {
    q: '¿Cuánto tiempo debo dedicarle cada día?',
    a: 'Entre 10 y 20 minutos diarios. El protocolo está diseñado para personas ocupadas — sin rituales complicados ni largas rutinas.'
  }, {
    q: '¿Cómo recibo el e-book?',
    a: 'Inmediatamente después de tu pago recibes un email con el enlace de descarga en PDF. Sin esperas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-light-navy py-20" data-id="element-12">
      <div className="max-w-3xl mx-auto px-4" data-id="element-13">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-primary text-center mb-12" data-id="element-14">
          Preguntas frecuentes
        </h2>

        <div className="space-y-4" data-id="element-15">
          {faqs.map((faq, i) => <div key={i} className="bg-white rounded-xl shadow-sm overflow-hidden transition-all duration-300" data-id="element-16">
              <button className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-17">
                <span className="font-bold text-text pr-8" data-id="element-18">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-primary transition-transform duration-300 flex-shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-19" />
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === i ? 'max-h-48 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-20">
                <p className="text-gray leading-relaxed" data-id="element-21">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}